module.exports = __webpack_public_path__ + "static/media/detail22.b5688b16.svg";